import { render, staticRenderFns } from "./EditarCuenta.vue?vue&type=template&id=f80a1fda&"
import script from "./EditarCuenta.vue?vue&type=script&lang=js&"
export * from "./EditarCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports